angular.module('dnecom.component.currency')
    .controller('CurrencyNavController', ["$scope", "$rootScope", "$timeout", "$http", "$filter", "CurrencyRates", function CurrencyNavController($scope, $rootScope, $timeout, $http, $filter, CurrencyRates) {
        $scope.loadingCurrencies = true;
        $scope.isNavVisible = false;
        $scope.showDropdown = false;
        $scope.currencies = [];
        $scope.isCurrencyEnabled = window.ies.store.currency.enabled;
        $scope.chosenCurrency = {
            code: CurrencyRates.fetchInitialCurrency()
        };

        $scope.select = function (currency) {
            $scope.chosenCurrency = angular.copy(currency);
            $scope.showDropdown = false;
            $scope.isNavVisible = false;
            $scope.search = null;

            $rootScope.$broadcast('overlay.hide');
            $rootScope.$broadcast('currency.changed', currency);
        };

        $scope.getCurrencies = function (search) {
            if (!search) {
                return _.takeWhile($scope.currencies, function (currency) {
                    return currency.order < 1000;
                });
            }

            return $filter('filter')($scope.currencies, { code: search }, function (actual, expected) {
                return _.startsWith(_.toLower(actual), _.toLower(expected));
            });
        };

        $http.get(Routing.generate('stores_fe_api_currencies'))
            .then(function(response) {
                if (!response || !response.data) {
                    throw "Request error";
                }

                $scope.currencies = response.data;
            }, function(e) {
                throw "Request error" + e;
            })
            .finally(function () {
                $scope.loadingCurrencies = false;
            });

        $scope.$on('currency.toggle', function () {
            $timeout(function() {
                $scope.isNavVisible = !$scope.isNavVisible;

                $rootScope.$broadcast(
                    $scope.isNavVisible ? 'overlay.show' : 'overlay.hide'
                );
            });
        });
    }]);
